module.exports = __webpack_public_path__ + "static/media/Storage-how-it-works-2.01c4051f.jpg";